import { IDropdown } from "../Components/Interfaces/IDropdown";
import { FieldModel, FieldDropdownComponent } from "../Components/Dropdowns/FieldDropdownComponent";
import { TemplateFieldTypes } from "../Areas/Admin/Shared/Models/TemplateFieldTypes";
import { ValueFieldHelper } from "../Components/Conditions/ValueFieldHelper";
import { TemplateFieldBase } from "../Areas/Admin/Measures/TemplateEdit/Models/TemplateFieldBase";
import { ITreeField } from "../Frame/GridViewSelect/ITreeField";
import { TemplateConditionContext } from "../Components/Conditions/ConditionContext/TemplateConditionContext";
import { DynamicFieldControlType } from "../Controls/Dynamic/DynamicFieldControlType";

export class FieldHelper {
    public static getValueType(fieldControl: IDropdown): string {
        let field: TemplateFieldBase | ITreeField;
        field = (fieldControl.getSelectedItem() as FieldModel)?.field;

        if (field) {
            if (field instanceof TemplateFieldBase) {
                return FieldHelper.getValueTypeForFieldType(field.type);
            } else {
                return FieldHelper.getValueTypeByTreeField(field as ITreeField);
            }
        }
    }

    public static getValueTypeForFieldType = (type: TemplateFieldTypes) => {
        switch (type) {
            case TemplateFieldTypes.Textzeile:
            case TemplateFieldTypes.RichText:
            case TemplateFieldTypes.Title:
            case TemplateFieldTypes.ParentContentText:
            case TemplateFieldTypes.NotesList:
                return "string";
            case TemplateFieldTypes.Mehrzeilig:
                return "multiline";
            case TemplateFieldTypes.Category:
                return "category"
            case TemplateFieldTypes.JaNein:
            case TemplateFieldTypes.BlockFinished:
                return "boolean"
            case TemplateFieldTypes.Zahl:
            case TemplateFieldTypes.ParentContentNumber:
            case TemplateFieldTypes.DateDiff:
                return "double";
            case TemplateFieldTypes.Datum:
            case TemplateFieldTypes.BlockDate:
            case TemplateFieldTypes.ParentContentDate:
                return "date";
            case TemplateFieldTypes.Benutzer:
            case TemplateFieldTypes.ParentContentUser:
            case TemplateFieldTypes.Responsible:
            case TemplateFieldTypes.BlockResponsible:
            case TemplateFieldTypes.UserList:
            case TemplateFieldTypes.ParentContentUserList:
                return "user";
            case TemplateFieldTypes.ParentStatus:
                return "parentstatus";
            case TemplateFieldTypes.ManualAmpel:
                return "ampel";
            case TemplateFieldTypes.DataFromSubmeasures:
                return "dataFromSubmeasures";
            default:
                return `A field of the type ${type.toString()} cannot be used as a condition.`;
        }
    }

    public static getValueTypeByTreeField(field: ITreeField) {
        if (field.fieldName.startsWith("LF#")) {
            // TemplateField, instanciate the TemplateFieldContext
            let templateContext = new TemplateConditionContext(null, undefined, undefined);
            return templateContext.getValueTypeForFieldType(TemplateFieldTypes[field.valueType]);

        } else if (field.fieldName.startsWith("CAT#")) {
            return "category";

        } else {
            // TableField
            switch (DynamicFieldControlType[field.valueType]) {
                case DynamicFieldControlType.TextBox:
                case DynamicFieldControlType.RichText:
                    return "string";
                case DynamicFieldControlType.MultiLine:
                    return "multiline";
                case DynamicFieldControlType.Category:
                    return "category";
                case DynamicFieldControlType.YesNo:
                    return "boolean";
                case DynamicFieldControlType.Int:
                    if (field.fieldName == "EreignisId") {
                        return "templateList"
                    } else if (field.fieldName == "Ampel") {
                        return "ampel";
                    } else {
                        return "int";
                    }
                case DynamicFieldControlType.Double:
                    return "double";
                case DynamicFieldControlType.DatePicker:
                    return "date";
                case DynamicFieldControlType.MultiUser:
                case DynamicFieldControlType.UserList:
                    return "user";
                case DynamicFieldControlType.MeasureList:
                    "measureList";

                default:
                    return `A field of type ${field.valueType} cannot be used as a condition`;
            }
        }
    }
}